export { default } from "./ProcessingRole";



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingRole/index.js